import { quoteStatus } from "../../enums";
import { tag } from "../../../theme/tokens/component/tag";

const normalize = (str) => str?.toLowerCase().replace(/[^a-z0-9]/g, '') ?? '';

const getBadge = (color, bold = true) => {
  const bgVariant = bold ? 'bold' : 'default';
  return {
    bg: tag.color.badge.bg[bgVariant][color],
    text: tag.color.badge.text.default[color],
  };
};

const buildStatusMap = (entries) =>
  Object.fromEntries(entries.map(([key, val]) => [normalize(key), val]));

// Maps status strings to semantic color tokens
const statusMap = buildStatusMap([
  // generic statuses
  ['Pending',    'warning'],
  ['Unknown',    'neutral'],
  ['Denied',     'neutral'],
  ['Incomplete', 'error'],

  // Order statuses
  ['Queued',       'neutral'],
  ['Received',     'neutral'],
  ['Acknowledged', 'caution'],
  ['En Route',     'warning'],
  ['Picking Up',   'warning'],
  ['On My Way',    'success'],
  ['Delivered',    'info'],
  ['Picked Up',    'info'],
  ['Completed',    'info'],

  // Approval statuses
  ['Pending Approval',      'error'],
  ['Pending Approval UM',   'error'],
  ['SecondLevel',           'error'],   // Pending Approval - Second Level
  ['FirstLevel',            'caution'], // Pending Approval - First Level
  ['Approval Escalated',    'error'],
  ['Not Approved',          'warning'],
  ['Not Approved UM',       'warning'],
  ['Partially Approved',    'success'],
  ['Partially Approved UM', 'success'],
  ['Approved',              'success'],
  ['Approved UM',           'success'],

  // Quote statuses
  [quoteStatus.providerQuote,   'error'],   // Provider Quote In Progress
  [quoteStatus.stateServeAudit, 'warning'], // Dragonfly Health Review
  [quoteStatus.clientReview,    'caution'], // Pending Quote Approval

  // Supply order statuses
  ['Submitted', 'neutral'],
  ['Shipping',  'warning'],

  // Equipment statuses
  ['Refused',       'error'],
  ['Not Necessary', 'error'],
  ['Disposable',    'error'],
  ['Lost',          'error'],

  // Prescription statuses
  ['Pending Review', 'caution'],
  ['Accepted',       'success'],
  ['Rejected',       'error'],
  ['Noncompliant',   'error'],

  // Patient statuses
  ['Active',                 'success'],
  ['Inactive',               'neutral'],
  ['Live Discharge',         'error'],
  ['Discharged (No Reason)', 'error'],
  ['NoReasonDischarge',      'error'],
  ['Expired',                'error'],

  // Equipment attributes
  ['Kit',       'neutral'],
  ['Approval',  'error'],
  ['Pre-Auth',  'warning'],
  ['Rx',        'warning'],
  ['OOF',       'error'],
  ['Formulary', 'info'],
  ['Non-CAP',   'error'],
  ['Cap',       'info'],
  ['Hidden',    'neutral'],

  // Contact attributes
  ['Primary',     'info'],
  ['Hospice',     'neutral'],
  ['Provider',    'neutral'],
  ['Nurse',       'neutral'],
  ['Technician',  'neutral'],

  // UM statuses
  ['Consult In Progress',    'caution'],
  ['Consult In Progress UM', 'caution'],
  ['Canceled',               'neutral'],
  ['Canceled UM',            'neutral'],
  ['Do Not Send To Dme',     'neutral'],
  ['Do Not Send To DMEUM',   'neutral'],

  // Scheduling statuses
  ['Patient Scheduling', 'neutral'],
  ['Provider Review',    'caution'],
  ['Patient Approval',   'caution'],
  ['Escalated',          'error'],
  ['Confirmed',          'success'],
  ['Rescheduled',        'warning'],

]);

const StatusColor = (status, bold = true) => {
  const color = statusMap[normalize(status)] ?? 'neutral';
  return getBadge(color, bold);
};

export default StatusColor;

